<template>
  <div :style="`min-height: ${min_height}px`">
    <transition name="slide" duration="100" mode="out-in">
      <v-form v-if="modelEditing" @submit.prevent="blurEditable" :class="{'pl-8': fake_hint}" ref="form">
        <slot name="editor" :item="modelValue" :setEditable="setEditable" :blurEditable="blurEditable" :modelEditing="modelEditing">
          <TextField
            ref="field" 
            v-bind="$attrs" 
            v-on="$listeners" 
            clearable
            v-model="modelValue" 
            @click:append-outer="blurEditable" 
            @focus.prevent="modelEditing = true"
            append-outer-icon="mdi-check"
            :key="1"
            :rule = rules
          >
          </TextField>
        </slot>
      </v-form>
      <InfoField :key="2" v-else v-bind="$attrs" v-on="$listeners" :dense="dense">
        <template #hint>
          <slot name="hint" :makeEditable="makeEditable">
              <v-btn @click="makeEditable" icon color="primary" small class="mr-2"><v-icon>mdi-pen</v-icon></v-btn>
          </slot>
        </template>
        <slot name="default" :makeEditable="makeEditable">
          {{ modelValue  }}
        </slot>
      </InfoField>
    </transition>
  </div>
</template>

<script>
import InfoField from '@/components/common/InfoField'
import TextField from '@/components/common/TextField'


export default {
  props: {
    value: String,
    min_height: {
      type: Number,
      default: 85
    },
    dense: Boolean,
    fake_hint: Boolean,
    rules: Array,
  },
  data: () => ({
    editing: false,
    isValid: true,
  }),
  methods: {
    makeEditable(){
      this.modelEditing = true

      // wait till input appears
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.field) {
            this.$refs.field.$el.getElementsByTagName('input')[0].focus()
          }
        });
      }, 200)
    },
    setEditable(v) {
      this.modelEditing = v
    },
    blurEditable() {
      if (this.isValid){
        this.$store.dispatch('hideKeyboard')
        
        this.$nextTick(() => {
          this.modelEditing = false
        })
      }
    },
    onKeyPress(e) {
      console.log(e)
    },
    focus() {
      this.makeEditable()
    },
    validateField(){
      if (this.rules != undefined){
        this.isValid = this.$refs.form.validate()
      }
    }
  },
  computed: {
    modelValue: {
      get(){
        return this.value
      },
      set(v) {
        // this.validateField()
        this.$emit('input', v)
      }
    },
    modelEditing: {
      get() {
        return this.editing || [undefined, null, ''].includes(this.modelValue)
      },
      set(v) {
        this.editing = v 
      }
    }
  },
  watch: {
    modelValue: 'validateField'
  },
  components: {
    InfoField,
    TextField
  }
}
</script>